import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GbVerifyNotificationComponent } from './gb-verify-notification/gb-verify-notification.component'
import { RouterModule, Routes } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { LetDirective } from '@ngrx/component'
import { TranslateModule } from '@ngx-translate/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

const routes: Routes = [{ path: '**', component: GbVerifyNotificationComponent }]
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    LetDirective,
    TranslateModule,
    MatProgressSpinnerModule,
  ],
  declarations: [GbVerifyNotificationComponent],
})
export class GbFrontAuthFeatureVerifyNotificationModule {}
